const GOOGLE_CLIENT_ID =
  '644706707764-hfngmb357d4f21ab0tmqb1cfu5muc432.apps.googleusercontent.com';
const GSI_SRC = 'https://accounts.google.com/gsi/client';

let loadPromise = null;

export function loadGoogleIdentity() {
  if (window.google?.accounts?.oauth2) {
    return Promise.resolve(window.google);
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const finish = () => {
      if (window.google?.accounts?.oauth2) {
        resolve(window.google);
      } else {
        reject(new Error('Google Sign-In failed to load'));
      }
    };

    const existing = document.querySelector(`script[src="${GSI_SRC}"]`);
    if (existing) {
      if (window.google?.accounts?.oauth2) {
        finish();
        return;
      }
      existing.addEventListener('load', finish, { once: true });
      existing.addEventListener('error', () => reject(new Error('Google Sign-In failed to load')), {
        once: true
      });
      return;
    }

    const script = document.createElement('script');
    script.src = GSI_SRC;
    script.async = true;
    script.defer = true;
    script.onload = finish;
    script.onerror = () => reject(new Error('Google Sign-In failed to load'));
    document.head.appendChild(script);
  }).catch((err) => {
    loadPromise = null;
    throw err;
  });

  return loadPromise;
}

export function googleLogin() {
  return loadGoogleIdentity().then(
    (google) =>
      new Promise((resolve, reject) => {
        const client = google.accounts.oauth2.initTokenClient({
          client_id: GOOGLE_CLIENT_ID,
          scope: 'openid email profile',
          callback: (resp) => {
            if (resp?.access_token) {
              resolve(resp.access_token);
              return;
            }
            if (resp?.error === 'popup_closed_by_user' || resp?.error === 'access_denied') {
              resolve(null);
              return;
            }
            reject(new Error('Google sign-in failed'));
          },
          error_callback: () => resolve(null)
        });
        client.requestAccessToken({ prompt: '' });
      })
  );
}

export { GOOGLE_CLIENT_ID };
